import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";
import type { ApprovedBriefItem, BriefApproval } from "../../../shared/types";

/** Review → Approved: briefs past approval (approved, scheduled, published), newest approval first. */
export function useApprovedBriefs(brandId: string | undefined, enabled = true) {
  return useQuery({
    queryKey: ["brand-review-approved", brandId],
    queryFn: async () => (await api.get<{ data: ApprovedBriefItem[] }>(
      `/api/brands/${encodeURIComponent(brandId!)}/review/approved`)).data,
    enabled: !!brandId && enabled,
  });
}

/** Who approved this brief and when (null when it was never approved). */
export function useBriefApproval(campaignId: string | undefined, briefId: string | undefined, enabled = true) {
  return useQuery({
    queryKey: ["brief-approval", campaignId, briefId],
    queryFn: async () => (await api.get<{ data: BriefApproval | null }>(
      `/api/campaigns/${encodeURIComponent(campaignId!)}/briefs/${encodeURIComponent(briefId!)}/approval`)).data,
    enabled: !!campaignId && !!briefId && enabled,
    retry: false,
  });
}
